import { Typography, TypographyProps } from "@mui/material";
import React from "react";

export type BooleanLabelProps = {
  value: boolean;
  type?: "yesno" | "active-in" | "onoff" | "enable-dis";
} & Omit<TypographyProps, "children">;

export function BooleanLabel({ value, type = "onoff", ...others }: BooleanLabelProps) {
  const getText = () => {
    switch (type) {
      case "yesno":
        return value ? "Yes" : "No";
      case "onoff":
        return value ? "On" : "Off";
      case "enable-dis":
        return value ? "Enabled" : "Disabled";
      case "active-in":
        return value ? "Active" : "Inactive";
    }
  };
  return (
    <Typography fontWeight={500} color={value ? "success.main" : "error.main"} {...others}>
      {getText()}
    </Typography>
  );
}

export default BooleanLabel;
